import script from "./form-platform.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-platform.vue?vue&type=script&setup=true&lang=ts"

import "./form-platform.vue?vue&type=style&index=0&id=52b8b213&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b8b213"]])

export default __exports__